/* eslint-disable import/prefer-default-export */
import { MutationHookOptions } from '@apollo/client'
import { useCallback } from 'react'

import { removeReleaseNotesFromPaginatedQuery } from '../cache'

import { CountReleaseNotesDocument, useDeleteReleaseNoteMutation } from '~generated/hooks'
import { DeleteReleaseNoteMutation, DeleteReleaseNoteMutationVariables } from '~generated/operations'
import { releaseNoteObjTypename } from '~lib/apollo/typenames'

export function useDeleteReleaseNote(
  baseOptions?: MutationHookOptions<DeleteReleaseNoteMutation, DeleteReleaseNoteMutationVariables>
) {
  const [deleteReleaseNoteMutation, options] = useDeleteReleaseNoteMutation(baseOptions)

  const deleteReleaseNote = useCallback(
    (id: string) => {
      return deleteReleaseNoteMutation({
        refetchQueries: [CountReleaseNotesDocument],

        variables: {
          id,
        },

        update: (cache) => {
          removeReleaseNotesFromPaginatedQuery(cache, [id])
          const cachedId = cache.identify({ id, __typename: releaseNoteObjTypename })
          cache.evict({ id: cachedId })
          cache.gc()
        },
      })
    },
    [deleteReleaseNoteMutation]
  )

  return [deleteReleaseNote, options] as const
}
